import { FormArtifactView } from '@kanbu/chatbot-ui';
import type { ShowFormArtifact } from '@kanbu/schema/contracts';

export interface FormPreviewPanelProps {
  artifact: ShowFormArtifact;
}

export function FormPreviewPanel({ artifact }: FormPreviewPanelProps) {
  return (
    <div className='sticky top-4'>
      <FormArtifactView artifact={artifact} previewMode />
    </div>
  );
}
